import { parseTwilioEnv } from "@humanizing/env";

let cachedEnv: ReturnType<typeof parseTwilioEnv> | null = null;

function getEnv() {
  if (!cachedEnv) {
    cachedEnv = parseTwilioEnv(process.env);
  }
  return cachedEnv;
}

export const env = new Proxy({} as ReturnType<typeof parseTwilioEnv>, {
  get(_target, property) {
    return getEnv()[property as keyof ReturnType<typeof parseTwilioEnv>];
  },
});

export const publicEnv = {
  nodeEnv: process.env.NODE_ENV,
  vercelEnv: process.env.NEXT_PUBLIC_VERCEL_ENV,
  sentryDsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
};

export default env;
